var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "verify-tree-grid" } },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { attrs: { slot: "operations" }, slot: "operations" }, [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticStyle: {
                    "margin-right": "10px",
                    "padding-top": "10px"
                  },
                  attrs: { "label-width": "100px", "label-position": "left" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.BusinessNo"),
                                prop: "jobNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "1" },
                                model: {
                                  value: _vm.query.jobNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "jobNo", $$v)
                                  },
                                  expression: "query.jobNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_CarrierShip"),
                                prop: "carrierId"
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                attrs: {
                                  no: "2",
                                  "method-params": {
                                    companyLob: "seaExport",
                                    seaCmp: true,
                                    active: true
                                  },
                                  "default-value": _vm.query.carrierId || "",
                                  placeholder: " "
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.carrierId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_BusinessDate"),
                                prop: "businessData"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "padding-bottom": "5px",
                                    display: "flex"
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "3",
                                      type: "date",
                                      "value-format": "yyyy-MM-dd"
                                    },
                                    model: {
                                      value: _vm.query.businessDateStart,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.query,
                                          "businessDateStart",
                                          $$v
                                        )
                                      },
                                      expression: "query.businessDateStart"
                                    }
                                  }),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_To")))
                                  ]),
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "4",
                                      type: "date",
                                      "value-format": "yyyy-MM-dd"
                                    },
                                    model: {
                                      value: _vm.query.businessDateEnd,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.query,
                                          "businessDateEnd",
                                          $$v
                                        )
                                      },
                                      expression: "query.businessDateEnd"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Mbl2"),
                                prop: "mblNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "5" },
                                model: {
                                  value: _vm.query.mblNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "mblNo", $$v)
                                  },
                                  expression: "query.mblNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Hbl2"),
                                prop: "hblNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "6" },
                                model: {
                                  value: _vm.query.hblNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "hblNo", $$v)
                                  },
                                  expression: "query.hblNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.Customer"),
                                prop: "customerId"
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                staticClass: "shipper-selector",
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "7",
                                  "popper-class": "shipper-selector-popper",
                                  "method-params": { customer: true },
                                  "default-value": _vm.query.customerId || "",
                                  placeholder: " "
                                },
                                on: {
                                  change: function(p) {
                                    _vm.query.customerId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "query-input-spacing",
                              attrs: {
                                label: _vm.$t("SeaExport.SoNo"),
                                prop: "soNo"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "8" },
                                model: {
                                  value: _vm.query.soNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.query, "soNo", $$v)
                                  },
                                  expression: "query.soNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { no: "9", type: "primary" },
                  on: { click: _vm.queryHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Search")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "10", type: "primary" },
                  on: { click: _vm.clearPage }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ResetFilter")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "11",
                    disabled: !_vm.btn.btNew,
                    type: "primary"
                  },
                  on: { click: _vm.addHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "12",
                    disabled: !_vm.btn.btEdit,
                    type: "primary"
                  },
                  on: { click: _vm.editHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "13",
                    disabled: !_vm.btn.btRemove,
                    type: "primary"
                  },
                  on: { click: _vm.deleteHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "14",
                    disabled: !_vm.btn.btnClone,
                    type: "primary"
                  },
                  on: { click: _vm.cloneHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "15",
                    disabled: !_vm.btn.btnSend,
                    type: "primary"
                  },
                  on: { click: _vm.onSendHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Send2")))]
              )
            ],
            1
          )
        ]),
        _c("div", { staticStyle: { display: "flex", height: "100%" } }, [
          _c(
            "div",
            {
              staticClass: "section",
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                width: "50%"
              }
            },
            [
              _c("cargo-ag-grid", {
                staticClass: "ag-theme-balham",
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "9500001",
                  "locale-text-func": _vm._i18nGridLocalText,
                  "grid-options": _vm.businessList.gridOptions,
                  "column-defs": _vm.businessList.columnDefs,
                  "row-data": _vm.businessList.rowData,
                  "grid-params": _vm.businessList.gridParams
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.businessList, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.businessList, "gridParams", $event)
                  },
                  gridReady: _vm.onGridReadyByBL
                }
              }),
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "9500003",
                  total: _vm.businessList.total,
                  page: _vm.businessList.filter.pageNum,
                  limit: _vm.businessList.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.businessList.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.businessList.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQueryByPage
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                width: "50%",
                height: "100%"
              }
            },
            [
              _c("cargo-ag-grid", {
                staticClass: "ag-theme-balham",
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "9500002",
                  "locale-text-func": _vm._i18nGridLocalText,
                  "grid-options": _vm.fileList.gridOptions,
                  "column-defs": _vm.fileList.columnDefs,
                  "row-data": _vm.fileList.rowData,
                  "grid-params": _vm.fileList.gridParams
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.fileList, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.fileList, "gridParams", $event)
                  },
                  gridReady: _vm.onGridReadyByFL
                }
              }),
              _c("div", { staticClass: "section" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "padding-top": "5px" },
                        attrs: {
                          inline: true,
                          "label-width": "60px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.FileType") }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "160px" },
                              attrs: {
                                no: "16",
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_TransmitFileType,
                                "default-value":
                                  _vm.fileList.selectedFile.fileType,
                                disabled: true
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.FileNo") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "250px" },
                              attrs: {
                                no: "17",
                                readonly: true,
                                disabled: true
                              },
                              model: {
                                value: _vm.fileList.selectedFile.fileNo,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fileList.selectedFile,
                                    "fileNo",
                                    $$v
                                  )
                                },
                                expression: "fileList.selectedFile.fileNo"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.fileView.txtCheckStatusOfCustomsDeclaration
                          ? _c(
                              "el-form-item",
                              { staticClass: "label-none custom" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      "text-decoration": "underline",
                                      border: "0"
                                    },
                                    attrs: { no: "18" },
                                    on: { click: _vm.stateQueryClickHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        this.$t(
                                          "SeaExport.CheckStatusOfCustomsDeclaration"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.fileView.checkPreRecordedCustomsDeclaration
                          ? _c(
                              "el-form-item",
                              { staticClass: "label-none custom" },
                              [
                                _c(
                                  "el-dropdown",
                                  {
                                    attrs: {
                                      no: "19",
                                      "split-button": "",
                                      type: "primary",
                                      trigger: "click"
                                    },
                                    on: { command: _vm.onLogPopUpMenu }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.fileView.command) + " "
                                    ),
                                    _vm._l(_vm.fileView.buttonArry, function(
                                      item
                                    ) {
                                      return _c(
                                        "el-dropdown-menu",
                                        {
                                          key: item.id,
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown"
                                        },
                                        [
                                          _c(
                                            "el-dropdown-item",
                                            { attrs: { command: item.value } },
                                            [_vm._v(_vm._s(item.value))]
                                          )
                                        ],
                                        1
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          inline: true,
                          "label-width": "60px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.TenBitCode") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "160px" },
                              attrs: {
                                no: "20",
                                readonly: true,
                                maxlength: "10",
                                disabled: true
                              },
                              model: {
                                value: _vm.fileList.selectedFile.tenDigitCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fileList.selectedFile,
                                    "tenDigitCode",
                                    $$v
                                  )
                                },
                                expression: "fileList.selectedFile.tenDigitCode"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.OperatingCompany")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "250px" },
                              attrs: {
                                no: "21",
                                readonly: true,
                                disabled: true
                              },
                              model: {
                                value: _vm.fileList.selectedFile.companyCname,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fileList.selectedFile,
                                    "companyCname",
                                    $$v
                                  )
                                },
                                expression: "fileList.selectedFile.companyCname"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          inline: true,
                          "label-width": "60px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.ReceiverCompanyName")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "160px" },
                              attrs: {
                                no: "22",
                                readonly: true,
                                disabled: true
                              },
                              model: {
                                value: _vm.fileList.selectedFile.receiveCompany,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fileList.selectedFile,
                                    "receiveCompany",
                                    $$v
                                  )
                                },
                                expression:
                                  "fileList.selectedFile.receiveCompany"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Receiver2") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100px" },
                              attrs: {
                                no: "23",
                                readonly: true,
                                disabled: true
                              },
                              model: {
                                value: _vm.fileList.selectedFile.receivePerson,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fileList.selectedFile,
                                    "receivePerson",
                                    $$v
                                  )
                                },
                                expression:
                                  "fileList.selectedFile.receivePerson"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Tel") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "120px" },
                              attrs: {
                                no: "24",
                                readonly: true,
                                disabled: true
                              },
                              model: {
                                value: _vm.fileList.selectedFile.receiveTel,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fileList.selectedFile,
                                    "receiveTel",
                                    $$v
                                  )
                                },
                                expression: "fileList.selectedFile.receiveTel"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          inline: true,
                          "label-width": "60px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: {
                              label: _vm.$t("SeaExport.CustomsDeclarationPages")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "160px" },
                              attrs: {
                                no: "25",
                                readonly: true,
                                disabled: true
                              },
                              model: {
                                value:
                                  _vm.fileList.selectedFile.customsPageNumber,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fileList.selectedFile,
                                    "customsPageNumber",
                                    $$v
                                  )
                                },
                                expression:
                                  "fileList.selectedFile.customsPageNumber"
                              }
                            }),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "padding-left": "10px" },
                                attrs: { disabled: true },
                                model: {
                                  value:
                                    _vm.fileList.selectedFile.customsTransfer,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fileList.selectedFile,
                                      "customsTransfer",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "fileList.selectedFile.customsTransfer"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.CustomsTransitOrNot")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.TradeMethod") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "140px" },
                              attrs: {
                                no: "26",
                                readonly: true,
                                disabled: true
                              },
                              model: {
                                value: _vm.fileList.selectedFile.tradeModeName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fileList.selectedFile,
                                    "tradeModeName",
                                    $$v
                                  )
                                },
                                expression:
                                  "fileList.selectedFile.tradeModeName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          inline: true,
                          "label-width": "60px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.CustomsBroker") }
                          },
                          [
                            _c("cargo-company-select", {
                              attrs: {
                                no: "27",
                                disabled: true,
                                "method-params": {
                                  customsBroker: true,
                                  seaExport: true,
                                  active: true
                                },
                                "default-value":
                                  _vm.fileList.selectedFile.customsBroker || "",
                                "custom-style": "width:160px;"
                              },
                              on: {
                                change: function(p) {
                                  _vm.fileList.selectedFile.customsBroker =
                                    p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: {
                              "padding-top": "5px",
                              "margin-right": "15px"
                            },
                            attrs: { no: "28", disabled: true },
                            model: {
                              value: _vm.fileList.selectedFile.tax,
                              callback: function($$v) {
                                _vm.$set(_vm.fileList.selectedFile, "tax", $$v)
                              },
                              expression: "fileList.selectedFile.tax"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.TakeByCustomsBroker"))
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.fileList.selectedFile.fileType === "3",
                                expression:
                                  "fileList.selectedFile.fileType==='3'"
                              }
                            ],
                            attrs: {
                              label: _vm.$t("SeaExport.DateOfDeclaration")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "29",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                disabled: true
                              },
                              model: {
                                value: _vm.fileList.selectedFile.declareDate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fileList.selectedFile,
                                    "declareDate",
                                    $$v
                                  )
                                },
                                expression: "fileList.selectedFile.declareDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          inline: true,
                          "label-width": "60px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.ExpressAddress") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "250px" },
                              attrs: {
                                no: "30",
                                type: "textarea",
                                rows: 3,
                                readonly: true,
                                disabled: true
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.ExpressAddress"),
                                    _vm.fileList.selectedFile.expressAddress,
                                    function(val) {
                                      _vm.fileList.selectedFile.expressAddress = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.fileList.selectedFile.expressAddress,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fileList.selectedFile,
                                    "expressAddress",
                                    $$v
                                  )
                                },
                                expression:
                                  "fileList.selectedFile.expressAddress"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Remarks") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "250px" },
                              attrs: {
                                no: "31",
                                type: "textarea",
                                rows: 3,
                                readonly: true,
                                disabled: true
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.Remarks"),
                                    _vm.fileList.selectedFile.remark,
                                    function(val) {
                                      _vm.fileList.selectedFile.remark = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.fileList.selectedFile.remark,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fileList.selectedFile,
                                    "remark",
                                    $$v
                                  )
                                },
                                expression: "fileList.selectedFile.remark"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("el-input", {
            attrs: { no: "32", type: "textarea", rows: "10" },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "33", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "34" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("customs-info-file-dialog", {
        ref: "customsInfoFile",
        attrs: {
          visible: _vm.customsInfoFiledialog.visible,
          model: _vm.customsInfoFiledialog.model,
          category: _vm.customsInfoFiledialog.category
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.customsInfoFiledialog, "visible", $event)
          }
        }
      }),
      _c("file-dialog", {
        ref: "fileDialog",
        attrs: {
          visible: _vm.editDialog.visible,
          backable: _vm.editDialog.backable,
          "selected-file": _vm.fileList.selectedFile,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          successHandler: _vm.successHandler
        }
      }),
      _c("dc-send-out-window", {
        ref: "dcSendOut",
        attrs: {
          "send-out-dialog": _vm.sendOutDialog,
          visible: _vm.sendOutDialog.visible,
          job: _vm.job,
          "selected-files": _vm.fileList.selectedFiles
        },
        on: {
          dcSendOutVisible: function($event) {
            _vm.sendOutDialog.visible = false
          },
          successHandler: _vm.successHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }